import { useContext, useRef } from "react";
import { Html } from "@react-three/drei";
import hotSpotIcon from "../../static/images/hotspot.png";
function HotSpot({
	hotspot,
	selectObject,
	transformControl,
	isPreviewComponent,
	setActivePanoId,
}) {
	const mesh = useRef(null);
	const onClickHandler = () => {
		if (!isPreviewComponent) {
			if (hotspot.link === null) return;
			setActivePanoId(hotspot.link);
		} else {
			selectObject(hotspot, mesh.current);
		}
	};
	return (
		<>
			<mesh ref={mesh} position={hotspot.position}>
				<Html center zIndexRange={[100, 10]}>
					<img
						className="hotspot"
						src={hotSpotIcon}
						alt="panorama"
						width="35px"
						height="35px"
						onClick={(e) => {
							onClickHandler();
						}}
					/>
				</Html>
			</mesh>
		</>
	);
}

export default HotSpot;
